import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=d4967872"
import script from "./Article.ts?vue&type=script&lang=ts&external"
export * from "./Article.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports